import React, { useState } from "react";
import "../../styles/FAQ.css";
import { useTranslation } from "react-i18next";
import "../../../i18n";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const faqData = [
    {
      category: t("faq_categories.orders"),
      questions: [
        {
          question: t("faq_questions.orders.0.question"),
          answer: t("faq_questions.orders.0.answer"),
        },
        {
          question: t("faq_questions.orders.1.question"),
          answer: t("faq_questions.orders.1.answer"),
        },
        {
          question: t("faq_questions.orders.2.question"),
          answer: t("faq_questions.orders.2.answer"),
        },
      ],
    },
    {
      category: t("faq_categories.payments"),
      questions: [
        {
          question: t("faq_questions.payments.0.question"),
          answer: t("faq_questions.payments.0.answer"),
        },
        {
          question: t("faq_questions.payments.1.question"),
          answer: t("faq_questions.payments.1.answer"),
        },
        {
          question: t("faq_questions.payments.2.question"),
          answer: t("faq_questions.payments.2.answer"),
        },
      ],
    },
    {
      category: t("faq_categories.product_pickup"),
      questions: [
        {
          question: t("faq_questions.product_pickup.0.question"),
          answer: t("faq_questions.product_pickup.0.answer"),
        },
        {
          question: t("faq_questions.product_pickup.1.question"),
          answer: t("faq_questions.product_pickup.1.answer"),
        },
        {
          question: t("faq_questions.product_pickup.2.question"),
          answer: t("faq_questions.product_pickup.2.answer"),
        },
        {
          question: t("faq_questions.product_pickup.3.question"),
          answer: t("faq_questions.product_pickup.3.answer"),
        },
        {
          question: t("faq_questions.product_pickup.4.question"),
          answer: t("faq_questions.product_pickup.4.answer"),
        },
      ],
    },
    {
      category: t("faq_categories.tickets"),
      questions: [
        {
          question: t("faq_questions.tickets.0.question"),
          answer: t("faq_questions.tickets.0.answer"),
        },
        {
          question: t("faq_questions.tickets.1.question"),
          answer: t("faq_questions.tickets.1.answer"),
        },
        {
          question: t("faq_questions.tickets.2.question"),
          answer: t("faq_questions.tickets.2.answer"),
        },
        {
          question: t("faq_questions.tickets.3.question"),
          answer: t("faq_questions.tickets.3.answer"),
        },
      ],
    },
    {
      category: t("faq_categories.tent_rentals"),
      questions: [
        {
          question: t("faq_questions.tent_rentals.0.question"),
          answer: t("faq_questions.tent_rentals.0.answer"),
        },
        {
          question: t("faq_questions.tent_rentals.1.question"),
          answer: t("faq_questions.tent_rentals.1.answer"),
        },
      ],
    },
    {
      category: t("faq_categories.support"),
      questions: [
        {
          question: t("faq_questions.support.0.question"),
          answer: t("faq_questions.support.0.answer"),
        },
        {
          question: t("faq_questions.support.1.question"),
          answer: t("faq_questions.support.1.answer"),
        },
      ],
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">{t("faq_title")}</h1>
      {faqData.map((section, sectionIndex) => (
        <div key={sectionIndex} className="faq-section">
          <h2 className="faq-category">{section.category}</h2>
          {section.questions.map((item, itemIndex) => {
            const currentIndex = `${sectionIndex}-${itemIndex}`;
            return (
              <div
                key={itemIndex}
                className={`faq-item ${openIndex === currentIndex ? "open" : ""}`}
              >
                <div
                  className="faq-question"
                  onClick={() => toggleAccordion(currentIndex)}
                >
                  {item.question}
                </div>
                {openIndex === currentIndex && (
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
